import _keyBy from 'lodash/keyBy';

// field names taken from format used in API requests
export const sortOptionsArr = [
  {
    sortField: 'class',
    sortDirection: 'desc',
  },
  {
    sortField: 'class',
    sortDirection: 'asc',
  },
  {
    sortField: 'class_datetime',
    sortDirection: 'desc',
  },
  {
    sortField: 'class_datetime',
    sortDirection: 'asc',
  },
  {
    sortField: 'venue',
    sortDirection: 'desc',
  },
  {
    sortField: 'venue',
    sortDirection: 'asc',
  },
  {
    sortField: 'status',
    sortDirection: 'desc',
  },
  {
    sortField: 'status',
    sortDirection: 'asc',
  },
];

// literally just the array as a map for simpler, quicker lookups. The performance benefit is negligible, but the code simplicity benefit is big.
export const sortOptionsMap = _keyBy(sortOptionsArr, item => `${item.sortField}_${item.sortDirection}`);
